const colors = {
    APP_WHITE: '#fefefe',
    APP_BLACK: '#000',
    APP_GRAY: '#ccc',
    APP_GRAY_LIGHT: '#eee',
    APP_GRAY_DARK: '#aaa',
    GRAY_BUTTON_TEXT: '#A6A6A6',
    LOGOUT_TEXT: '#848484',

    LIGHT_BLUE: '#CBDDEE',
    SELECTED_TEXT: '#1967D2',
    APP_BACKGROUND: '#F2F2F3',
    PRIMARY_COLOR: '#1967D2',
    PRIMARY_HOVER: '#323232',
    SECONDARY_COLOR: '#323232',
    PRIMARY_TEXT: '#323232',
    INPUT_BACKGROUND: '#E9E9E9',
    ERROR_TEXT: 'red',
    SUCCESS_TEXT: '#6AC86E',
    ICONS_BACKGROUND: '#EBEBEB',
    CANCEL_BUTTON_BACKGROUND: '#EBEBEB',
    NOTIFICATIONS_BADGE: '#FF0C0C',
    PRIORITY_CHIP: '#f8f8f8',
    TABLE_BORDERS: 'rgba(50, 50, 50, 0.2)',
    TABLE_GREY_ROW: 'rgba(235,235,235,0.5)',
    CARD_TITLE_BACKGROUND: '#F9F9F9',

    WAITING_STATUS: '#FF7A00',
    APPROVED_STATUS: '#2E7C31',
    DELETED_STATUS: '#DD1A1A',
    PDF_ICON: '#F40F02',
    LIGHT_YELLOW: 'rgba(255, 199, 0, 0.25)',
    YELLOW: '#FFC700',

    LINK_TEXT: '#1276E6',
}

export default colors
